module.exports = __webpack_public_path__ + "static/media/bn.427230e8.svg";